"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSettings = void 0;
var React = __importStar(require("react"));
var IconSettings = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M12.0003719,16 C9.7923719,16 8.0003719,14.21 8.0003719,12 C8.0003719,9.79 9.7923719,8 12.0003719,8 C14.2073719,8 16.0003719,9.79 16.0003719,12 C16.0003719,14.21 14.2073719,16 12.0003719,16 L12.0003719,16 Z M19.4213719,12.717 C19.4413719,12.49 19.4573719,12.26 19.4573719,12.029 C19.4573719,11.803 19.4453719,11.58 19.4253719,11.361 L21.8713719,9.226 C22.0043719,9.108 22.0363719,8.921 21.9563719,8.78 L19.8723719,5.28 C19.7913719,5.14 19.6063719,5.085 19.4413719,5.136 L16.3233719,6.124 C15.9443719,5.862 15.5423719,5.636 15.1203719,5.444 L14.4363719,2.305 C14.3993719,2.137 14.2473719,2 14.0823719,2 L9.9223719,2 C9.7573719,2 9.6113719,2.137 9.5753719,2.305 L8.8963719,5.44 C8.4733719,5.628 8.0743719,5.851 7.7003719,6.108 L4.5663719,5.116 C4.3973719,5.062 4.2123719,5.132 4.1323719,5.269 L2.0473719,8.772 C1.9673719,8.913 2.0073719,9.097 2.1363719,9.21 L4.5783719,11.342 C4.5583719,11.568 4.5463719,11.795 4.5463719,12.025 C4.5463719,12.248 4.5583719,12.471 4.5783719,12.689 L2.1283719,14.829 C1.9953719,14.946 1.9633719,15.134 2.0433719,15.274 L4.1233719,18.778 C4.2043719,18.919 4.3893719,18.974 4.5543719,18.923 L7.6773719,17.935 C8.0553719,18.196 8.4533719,18.423 8.8793719,18.614 L9.5603719,21.727 C9.5963719,21.895 9.7483719,22 9.9133719,22 L14.0743719,22 C14.2383719,22 14.3843719,21.891 14.4203719,21.727 L15.0963719,18.63 C15.5263719,18.438 15.9333719,18.208 16.3143719,17.946 L19.4343719,18.938 C19.6033719,18.993 19.7873719,18.927 19.8683719,18.79 L21.9483719,15.286 C22.0283719,15.146 21.9923719,14.966 21.8593719,14.849 L19.4213719,12.717 Z" }))); };
exports.IconSettings = IconSettings;
exports.IconSettings.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconSettings;
